import PropTypes from 'prop-types';
import { path } from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createResource } from 'redux-json-api';

import { Grid, Row, Col } from 'react-flexbox-grid';
import CardHeader from '@material-ui/core/CardHeader';

import RouteBlockageForm from './RouteBlockageForm';
import { closeLeftBar, showSnackbarMessage } from '../modules/actions/layout';

const styles = {
  formContainer: {
    margin: 20,
    width: '100%',
  },
};

class AddRouteBlockage extends Component {
  static propTypes = {
    createResource: PropTypes.func.isRequired,
    apiEndpoint: PropTypes.string.isRequired,
    closeLeftBar: PropTypes.func.isRequired,
    showSnackbarMessage: PropTypes.func.isRequired,
  };

  render () {
    const { createResource, apiEndpoint, closeLeftBar, showSnackbarMessage } = this.props;

    return (
      <Grid fluid>
        <Row>
          <Col style={styles.formContainer}>
            <CardHeader title="Stremming aanmaken" />

            <RouteBlockageForm
              onSubmit={async (values) => {
                try {
                  const entity = {
                    type: 'route-blockage',
                    attributes: {
                      'expected-duration': values.expected_duration,
                      'start-at': values.start_at,
                      'railway': `${apiEndpoint}/railway/${values.railway}`,
                      'stop-from': `${apiEndpoint}/stop/${values.stop_from}`,
                      'stop-to': `${apiEndpoint}/stop/${values.stop_to}`,
                      'vehicles-required': values.vehicles_required,
                      'invited-preferred-companies': values.preferred_companies.map(companyId => (
                        `${apiEndpoint}/company/${companyId}`
                      )),
                      'invited-companies': values.companies.map(companyId => (
                        `${apiEndpoint}/company/${companyId}`
                      )),
                      'invite-non-preferred-companies': values.invite_non_preferred_companies,
                    }
                  };

                  await createResource(entity);
                  closeLeftBar();
                  showSnackbarMessage('Nieuwe stremming aangemaakt');
                } catch (exc) {
                  console.warn('exception', exc);
                  showSnackbarMessage('Er is iets fout gegaan bij het aanmaken van de stremming!');
                }
              }}
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  apiEndpoint: path(['api', 'endpoint', 'axiosConfig', 'baseURL'], state),
});

const mapDispatchToProps = {
  createResource,
  closeLeftBar,
  showSnackbarMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(AddRouteBlockage);
